import React from 'react';
import {  Grid, Typography, Button  } from '@mui/material';
import NotFoundImg from '../assets/404.png'
import { useNavigate } from "react-router-dom";

const PageNotFound = () => {
    const navigate = useNavigate();
    return (
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: '80vh' }}
      >
        <img style={{maxWidth:'100%'}} alt="not_found" src={NotFoundImg}  />
        <Typography sx={{paddingBottom:'10px'}} variant="h6">Page Not Found!</Typography>
        <Typography sx={{paddingBottom:'20px'}} variant="span">The page you’re looking for doesn’t exist.</Typography>
        <Button onClick={(e)=>{navigate('/web/dashboard')}}  variant="contained">Dashboard</Button>
      </Grid>
  )
}

export default PageNotFound